import { Component, OnInit, Input, OnDestroy, Inject, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { ProdutoComentarios } from '../../../../models/produtoComentarios.model';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { UsersService } from '../../../../models/usuarios.service';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SharedModule } from '../../shared/shared.module';
import { getTableNameFull, DataModel } from '../../../../models/data.model';

@Component({
    selector: 'produto-comentarios',
    template: `
    <div fxLayoutAlign="end start">
    <button  mat-button- (click)="addNovoComentario()">Comentar</button>
    </div>
    <div *ngFor="let comentario of comentarios" fxLayout="column">
    <mat-vertical-stepper>
      <mat-step>
      <ng-template matStepLabel>       
           {{isoDateToString(comentario.data)}} - {{comentario.usuario}}
      </ng-template>
           <div>{{comentario.mensagem}}</div>
           <mat-chip-list>
             <mat-chip 
                (click)="gosteiClick(comentario)">Gostei 
                <span matBadge="{{comentario.gostei}}"></span>
             </mat-chip>
             <mat-chip *ngIf="comentario.finalizado==false" (click)="arquivarClick(comentario)">Arquivar</mat-chip>
           </mat-chip-list>
      </mat-step>
    </mat-vertical-stepper>
    </div>
    `,
    styles: [``]
})
export class ProdutoComentariosComponent implements OnInit, OnDestroy {
    comentEvent: Subscription;
    fItem: any = {};
    comentarios = [];
    comentClass: ProdutoComentarios = null;

    config: MatDialogConfig = {
        width: '350',
        height: '420',
        data: {
            titulo: "",
            mensagem: ""
        }
    }


    @Input()
    get item() {
        return this.fItem;
    }
    set item(x) {
        if (this.fItem !== x) {
            if (this.fItem.codigo !== x.codigo)
                this.fItem = x;
            this.startFetch();
        }
    }
    constructor(private db: AngularFirestore,
        private users: UsersService,
        public dialog: MatDialog) {

        this.comentClass = new ProdutoComentarios(this.db,
            this.item.fornecedor,
            this.item.codigo,
            this.users);
        this.comentEvent = this.comentClass.changedEvent.subscribe(
            r => {
                
                this.comentarios = r;
            }
        )
    }

    ngOnInit(): void {

    }
    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.comentEvent.unsubscribe();
    }

    isoDateToString(d){
        return DataModel.toDateLocale(d);
    }

    gosteiClick(coment){
      this.comentClass.gostei(coment);
    }
    arquivarClick(coment){
      this.comentClass.arquivar(coment);
    }

    addNovoComentario() {

        const dialogConfig = new MatDialogConfig();
        //dialogConfig.disableClose = false;
        //dialogConfig.autoFocus = true;
        let comentarioRef = this.dialog.open(ComentariosDialog, {width:'350px'} );
        comentarioRef.afterClosed().subscribe(
            dados => {
                if (dados) {
                    if (dados.mensagem>"")
                    this.comentClass.add(
                        {
                            fornecedor: this.item.fornecedor,
                            codigo: this.item.codigo,
                            data: new Date(),
                            usuario: this.users.usuario.nome,
                            email: this.users.usuario.email,
                            mensagem: dados.mensagem,
                            finalizado:false,
                        })
                }
            }
        )

    }

    startFetch() {
        if (this.item.fornecedor) {
            this.comentClass.getComentarios(
                this.item.fornecedor,
                this.item.codigo
            )
        }

    }

}

@Component({
    selector: 'comentarios-dialog',
    template: `
      <section>
      
        <mat-card class="no-border">
            <mat-card-header>
                <mat-card-title>Olá, deixa seu comentário para o produto</mat-card-title>
            </mat-card-header>
            <mat-card-content fxLayout="column">
            <!--form fxFlex fxLayout="column"-->
                <mat-form-field>
                   <textarea fxFlex cdkAutosizeTextarea 
                    matInput name="mensagem" rows="5" 
                    placeholder="Mensagem" [(ngModel)]="mensagem"></textarea>
                </mat-form-field>
            <!--/form-->
            </mat-card-content>
            <mat-card-actions align="start">
                <button  mat-button (click)="enviar()"><mat-icon>check</mat-icon></button>
                <button  mat-button (click)="fechar()"><mat-icon>close</mat-icon></button>
                
            </mat-card-actions>
        </mat-card>

        
      </section>
    `,
    styles: [`.no-border{
      box-shadow: none;   
    }`]
})
export class ComentariosDialog implements OnInit {
    titulo = "";
    mensagem = "";
    form:FormGroup;
    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<ComentariosDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit(){
     this.form = this.fb.group({
         mensagem:["", Validators.minLength(15)]
     })  
    }   

    valid(){
        return this.mensagem.length>15;
    }

    enviar() {
        this.dialogRef.close({mensagem:this.mensagem});
    }
    fechar() {
        this.dialogRef.close(null);
    }
}


@NgModule({
    declarations: [ProdutoComentariosComponent, ComentariosDialog],
    imports: [CommonModule, SharedModule,FormsModule, ReactiveFormsModule],
    exports: [ProdutoComentariosComponent,],
    providers: [],
    entryComponents: [
        ComentariosDialog
    ],
    schemas:[
        CUSTOM_ELEMENTS_SCHEMA,
    ]
})
export class ComentariosModule { }
